import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cash-pricing__price-pool-header"
}
const _hoisted_2 = { class: "cash-pricing__price-pool-header" }
const _hoisted_3 = {
  key: 0,
  class: "cash-pricing__accordion-header"
}
const _hoisted_4 = { class: "cash-pricing__accordion-toggle" }
const _hoisted_5 = { class: "cash-pricing__pool-badge" }
const _hoisted_6 = { class: "cash-pricing__table-scroller" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "cash-pricing__table-more"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "accordion__header" }
const _hoisted_14 = {
  class: "accordion__toggle collapsed",
  "aria-expanded": "false",
  "aria-controls": "accordion-75"
}
const _hoisted_15 = { class: "accordion__toggle-text" }
const _hoisted_16 = { class: "cash-pricing__accordion-toggle" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "accordion__toggle-icon-wrapper" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_vit_accordion = _resolveComponent("vit-accordion")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cash-pricing__table-container", { 'cash-pricing__table-container--narrow': _ctx.hideGroupTitle }])
  }, [
    (!_ctx.hideGroupTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.group.title), 1),
          (_ctx.group.type === 'commodity')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "cash-pricing__deselect-group-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove', _ctx.group.id)))
              }, [
                _createVNode(_component_icon, {
                  name: "icn-cross",
                  class: "icon"
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.group.gradePools && _ctx.group.gradePools.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!_ctx.hideGroupTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", null, _toDisplayString(_ctx.group.type === 'site' ? _ctx.translations.grade : _ctx.translations.site), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.translations.price), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group.gradePools, (gradePool) => {
            return (_openBlock(), _createBlock(_component_vit_accordion, {
              key: gradePool.id,
              onCollapse: ($event: any) => (_ctx.onCollapseTable(gradePool.id)),
              "expand-text": _ctx.translations.more,
              "collapse-text": _ctx.translations.less
            }, {
              toggle: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(gradePool.title) + " ", 1),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(gradePool.prices.length), 1)
                  ]),
                  _createElementVNode("div", null, _toDisplayString(gradePool.max > 0 ? '$' + gradePool.max : _ctx.translations.noPrice), 1)
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("table", {
                    class: _normalizeClass(["table cash-pricing__table", { 'table--transparent': _ctx.transparent }])
                  }, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SortOption, (th, index) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: `${_ctx.group}-${th}-${index}`,
                            onClick: ($event: any) => (_ctx.sortTable(th, gradePool.id))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.translations[th]) + " ", 1),
                            _createVNode(_component_icon, {
                              name: "icn-sort-arrow",
                              class: _normalizeClass(`cash-pricing__sort-arrow cash-pricing__sort-arrow-${_ctx.getSortDir(th, gradePool.id)}`)
                            }, null, 8, ["class"])
                          ], 8, _hoisted_7))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSortedPrices(gradePool.prices, gradePool.id), (price, p) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: `${gradePool.id}-${p}`
                        }, [
                          _createElementVNode("td", null, _toDisplayString(price.owner.oDescription), 1),
                          (price.sellInfo.isPool)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(price.price), 1))
                            : (_openBlock(), _createElementBlock("td", _hoisted_9, " $" + _toDisplayString(price.price.toFixed(2)), 1)),
                          _createElementVNode("td", null, _toDisplayString(price.sellInfo.sOptionDescription), 1),
                          _createElementVNode("td", null, _toDisplayString(price.sellInfo.pTermDescription), 1)
                        ]))
                      }), 128))
                    ])
                  ], 2)
                ]),
                (!_ctx.isExpanded(gradePool.id) && gradePool.prices.length > 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "button button--down",
                        onClick: ($event: any) => (_ctx.expand(gradePool.id))
                      }, _toDisplayString(_ctx.translations.load), 9, _hoisted_11)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["onCollapse", "expand-text", "collapse-text"]))
          }), 128))
        ], 64))
      : (_ctx.showEmptyGrades)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.group.title), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.translations.noIndivPriceGrade), 1)
                  ])
                ]),
                _hoisted_17
              ])
            ])
          ]))
        : _renderSlot(_ctx.$slots, "default", { key: 3 })
  ], 2))
}